import { ReportIssueKey } from "../types";
import { ReportIssueConfirmPanel } from "./ReportIssueConfirm";
import { ReportIssueFormPanel } from "./ReportIssueForm";
import { ReportIssueListPanel } from "./ReportIssueList";

export const panels = [
  { key: ReportIssueKey.ReportIssueFormPanel, panel: ReportIssueFormPanel },
  { key: ReportIssueKey.ReportIssueConfirmPanel, panel: ReportIssueConfirmPanel },
  { key: ReportIssueKey.ReportIssueListPanel, panel: ReportIssueListPanel },
];
